const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));

  let payload = filters.map(item => {
    if (Array.isArray(item.values)) {
      item.values = item.values.map(val =>
        typeof val === 'object' && val !== null ? val.id : val
      );
    } else if (typeof item.values === 'object' && item.values !== null) {
      item.values = [item.values.id];
    } else if (!item.values) {
      item.values = [];
    } else {
      item.values = [item.values];
    }
    return item;
  });
  if (payload.length > 0) {
    payload[payload.length - 1].query_operator = undefined;
  }

  return { payload };
};

export default generatePayload;
